// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var UnitOfArea;
(function (UnitOfArea) {
    UnitOfArea["SquareMeter"] = "squareMeter";
    UnitOfArea["SquareFoot"] = "squareFoot";
    UnitOfArea["Acre"] = "acre";
    UnitOfArea["Hectare"] = "hectare";
})(UnitOfArea || (UnitOfArea = {}));
export function UnitOfAreaFromJSON(json) {
    return json;
}
export function UnitOfAreaToJSON(value) {
    return value;
}
